import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { clipboardText: String }

  /**
   * Copies the `data-clipboard-text` value to the clipboard when clicked.
   */
  copy(event) {
    event.preventDefault();

    const textToCopy = this.clipboardTextValue;
    if (!textToCopy) {
      console.error("No text provided for copying.");
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Modern Clipboard API
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showCopyFeedback();
        })
        .catch((err) => {
          console.error("Failed to copy text using Clipboard API: ", err);
        });
    } else {
      // Fallback for unsupported environments
      this.fallbackCopyText(textToCopy);
      this.showCopyFeedback();
    }
  }

  /**
   * Fallback: Copies text to the clipboard using a hidden textarea.
   */
  fallbackCopyText(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Fallback copy failed: ", err);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  /**
   * Temporarily replaces the current content with a Bootstrap icon as feedback.
   */
  showCopyFeedback() {
    const originalHTML = this.element.innerHTML;
    this.element.innerHTML = '<i class="bi bi-clipboard-check"></i>';
    setTimeout(() => {
      this.element.innerHTML = originalHTML;
    }, 2000);
  }
}
